"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  distance: {
    tiny: '0.25rem',
    small: '0.5rem',
    normal: '1rem',
    double: '2rem'
  },
  colors: {
    black: '#121212',
    blue: '#299EFF',
    bluegray: '#CFD8DC',
    darkgray: '#444444',
    darkgreen: '#009a10',
    gray: '#595959',
    green: '#38D42F',
    lightblue: '#b8dcff',
    lightgray: '#B4B4B4',
    lightergray: '#D5D5D5',
    orange: '#FE9900',
    pink: '#FF40B2',
    red: '#FC4238',
    textgray: '#6F6F6F',
    variantColors: ['#1b5e21', '#1B5E20', '#218E3C', '#22A44D', '#21B75F', '#28C872', '#39D687', '#51E19A', '#71EBAD', '#97F3C2', '#C4FADB', '#C7FADD'],
    white: '#FFFFFF',
    yellow: '#FFD600',
    inputDisabledGray: '#E7E7E7'
  },
  type: {
    family: {
      content: '"Roboto", Helvetica, Arial, sans-serif',
      system: '"Roboto Condensed", Helvetica, Arial, sans-serif'
    },
    size: {
      tiny: '0.875rem',
      small: '0.9rem',
      normal: '1rem',
      large: '1.125rem',
      large1: '1.25rem',
      giant: '1.7rem',
      extra: '2.3rem'
    },
    weight: {
      light: '300',
      regular: '400',
      medium: '500',
      bold: '700',
      black: '900'
    },
    lineHeight: {
      none: 1.0,
      regular: 1.3,
      large: 1.5,
      extra: 2.5
    },
    capitalize: {
      allcaps: 'uppercase'
    }
  },
  radius: {
    regular: '4px'
  }
};
exports.default = _default;